/** Cài đặt chấm điểm hội thoại của doanh nghiệp (BE: POST /chatbot/ai/scoresettings, BusinessSettings type 41). */
export type AiScoreVisibility = 'managers' | 'own' | 'all';

export const AI_SCORE_VISIBILITIES: AiScoreVisibility[] = ['managers', 'own', 'all'];

/** 1 = thứ Hai … 7 = Chủ nhật (ISO-8601, giống date('N') bên BE). */
export const AI_SCORE_WEEK_DAYS = [1, 2, 3, 4, 5, 6, 7] as const;

export interface IAiScoreCriterion {
  key: string;
  name: string;
  /** Mô tả cho AI: hướng dẫn chấm, nên kèm khi nào Đạt, khi nào Không đạt, khi nào N/A. */
  guide: string;
  scale: 'binary' | '0-3';
  /** 1-10 */
  weight: number;
  /** Rớt tiêu chí Quan trọng thì cả phiên Không đạt. */
  critical: boolean;
  /** machine: tính từ dữ liệu (phản hồi lần đầu), không gọi AI. */
  source: 'ai' | 'machine';
  enabled: boolean;
}

export interface IAiScoreWorkingHours {
  /** Bật thì bỏ phiên nằm hoàn toàn ngoài giờ và không tính thời gian chờ ngoài giờ. */
  enabled: boolean;
  days: number[];
  /** HH:MM */
  from: string;
  to: string;
}

export interface IAiScoreSettings {
  /** Trợ lý dùng để chấm (tài khoản và model); trống = theo trợ lý gợi ý của page. */
  assistantId: string;
  passThreshold: number;
  visibility: AiScoreVisibility;
  /** Nhân viên chỉ thấy Đạt/Không đạt, không thấy điểm số. */
  staffHidePercent: boolean;
  responseTargetMinutes: number;
  criteria: IAiScoreCriterion[];
  /** {BIẾN} khớp một đoạn bất kỳ, không phân biệt hoa thường và dấu. */
  closingPhrases: string[];
  workingHours: IAiScoreWorkingHours;
  /** Tối đa phiên tự chấm mỗi ngày của cả doanh nghiệp (1-5000, BE mặc định 200). */
  autoDailyLimit: number;
  version: number;
  updatedAt: number;
  updatedBy: string;
}

/** Giới hạn phiên tự chấm mỗi ngày của doanh nghiệp (khớp BE ScoreSettingsService). */
export const AI_SCORE_AUTO_DAILY_LIMIT = { min: 1, max: 5000, default: 200 } as const;
/** Hết phiên khi khách im lặng (phút) và tỉ lệ phiên được tự chấm, giống cài đặt aiScore của page bên BE. */
export const AI_SCORE_SESSION_GAPS = [30, 60, 120, 240, 360] as const;
export const AI_SCORE_SAMPLE_RATES = [10, 20, 50, 100] as const;

/** Tự chấm điểm của một page (settings.aiScore); status, onOpen: 1 bật, 2 tắt. */
export interface IAiScorePageAuto {
  status: number;
  sessionGapMinutes: number;
  sampleRate: number;
  onOpen: number;
}

/** Một dòng bảng Tự chấm điểm: page, trợ lý đang gắn (chưa gắn thì không bật được), cài đặt tự chấm. */
export interface IAiScorePageRow {
  pageId: string;
  name: string;
  avatar: string;
  channel: number;
  assistant: { id: string; name: string } | null;
  aiScore: IAiScorePageAuto;
}

/** Đổi tự chấm của page, gửi cùng settings (BE nhận pages là chuỗi JSON). */
export type IAiScorePageUpdate = { pageId: string } & Partial<IAiScorePageAuto>;

export interface IAiScoreSettingsData {
  settings: IAiScoreSettings;
  defaultCriteria: IAiScoreCriterion[];
  assistants: { id: string; name: string; model: string }[];
  limits: { criteria: number; critical: number; closingPhrases: number };
  /** Bảng tự chấm theo page (page có trợ lý lên đầu). */
  pages?: IAiScorePageRow[];
  /** Số phiên đã tự chấm hôm nay của doanh nghiệp. */
  usage?: { autoToday: number };
}
